import React from 'react';

import { html } from '@codemirror/lang-html';
import { json } from '@codemirror/lang-json';
import { defaultHighlightStyle, foldGutter, syntaxHighlighting } from '@codemirror/language';
import { EditorState } from '@codemirror/state';
import { EditorView, lineNumbers } from '@codemirror/view';
import { type SxProps } from '@mui/material';

import BaseCodeMirror from './hoc/BaseCodeMirror';

const HTML_PREVIEW = [
  lineNumbers(),
  foldGutter(),
  syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
  html(),
  EditorView.editable.of(false),
  EditorState.readOnly.of(true),
];

const JSON_PREVIEW = [
  lineNumbers(),
  foldGutter(),
  syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
  json(),
  EditorView.editable.of(false),
  EditorState.readOnly.of(true),
];

function useReadOnlyLanguageExtensions(language: CodeMirrorLanguage) {
  switch (language) {
    case 'HTML':
      return HTML_PREVIEW;
    case 'JSON':
      return JSON_PREVIEW;
  }
}

type CodeMirrorLanguage = 'HTML' | 'JSON';
type Props = {
  language: CodeMirrorLanguage;
  value: string;
  sx?: SxProps;
};
export default function CodeMirrorPreview({ language, value, sx }: Props) {
  const extensions = useReadOnlyLanguageExtensions(language);
  return <BaseCodeMirror defaultValue={value} extensions={extensions} sx={{ ...sx }} />;
}
